module.exports = __webpack_public_path__ + "static/img/rank_55.22b62e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_55.png
// module id = KZP1
// module chunks = 1